import { render } from "./NotUsableChoicesComparison.vue?vue&type=template&id=62bad9c2&scoped=true"
import script from "./NotUsableChoicesComparison.vue?vue&type=script&lang=js"
export * from "./NotUsableChoicesComparison.vue?vue&type=script&lang=js"

import "./NotUsableChoicesComparison.vue?vue&type=style&index=0&id=62bad9c2&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62bad9c2"]])

export default __exports__